import React, {useEffect} from 'react';
import {useParams} from "react-router-dom";
import SimpleCardContainer from "../../ui/SimpleCardContainer";
import {useApi} from "../../../providers/ApiProvider";
import BusinessesModel from "../../../models/BusinessesModel";
import BusinessesWidgetsModel from "../../../models/BusinessesWidgetsModel";
import {useBreadcrumbs} from "../../../providers/BreadcrumbsProvider";
import BusinessViewHeader from "./../BusinessViewHeader";
import BusinessViewMenu from "../BusinessViewMenu";
import {useNotifications} from "../../../providers/NotificationsProvider";
import {useTranslation} from "react-i18next";
import {useTranslation as useMyTranslation} from "../../../providers/TranslationProvider";
function BusinessesWidget(props) {
	
    const {language} 				= useMyTranslation()
	;	
    const { t} 						= useTranslation();	
	
    const params 					= useParams();	
	
    const apiContext 				= useApi();
	
    const businessesWidget 			= new BusinessesWidgetsModel(apiContext.api);
	
    const businessesModel 			= new BusinessesModel(apiContext.api);
	
    const [profile, setProfile] 	= React.useState({});
	
    const [code, setCode] 			= React.useState('');
	
    const [widgetId, setWidgetId] 	= React.useState('');
	
	const notifications 			= useNotifications();
	
    const [icons, setIcons] 		= React.useState([]);
	
    const [style, setStyle] 		= React.useState('');
	
    const breadcrumbs 				= useBreadcrumbs();
	
	const [options, setOptions] 	= React.useState({});
    const initWidget = () => {
		
		businessesWidget.get(params.locationId).then((response) => {
		
            if (response !== false) {
				console.log('options');
				console.log(response.options);
				
				setWidgetId(response.widget_id);
				setIcons(response.icons);
				setStyle(response.style);
				setOptions(response.options);
				setCode('<script id="lbGbadge" src="'+process.env.REACT_APP_API_URL + '/widgets/'+response.widget_id+'"></script>');               
            }
        });
		
	}
	
    const setMetaData = (profile) => {
	
        if (profile !== false) {
		
            breadcrumbs.update({
			
                title: profile.title,
                breadcrumbs: [
				
                    {label: t('Businesses List'), url: '/businesses'},
                    {label: profile.title, url: '/businesses/'+params.locationId},
                    {label: t('Widget')}
                ]
            });
            document.title = t('Widget')+' | '+profile.title+' | LocalBoost';
        }
    }
    const onProfileRefresh = (profile, lastUpdated) => {
	
        setMetaData(profile);
    }
	
	
    useEffect(() => {
	
        businessesModel.view(params.locationId).then((response) => {
		
            if (response !== false) {
			
                setMetaData(response.data);
				setProfile(response.data);
				console.log('response');
				console.log(response);
			}
        });
		
		initWidget();
		
    }, [language]);	
    useEffect(() => {
		
		initWidget();
    }, []);
	
	const generateWidget = () =>{	
	
		let position 		= document.getElementById('badge-position');
		let marginTop 		= document.getElementById('badgeTop');
		let marginBottom 	= document.getElementById('badgeBottom');
		let marginLeft 		= document.getElementById('badgeLeft');
		let marginRight 	= document.getElementById('badgeRight');
		
		if(position.value == 'tl'){
			
			marginRight.style.display = 'none';
			marginBottom.style.display = 'none';
			marginTop.style.display = 'block';
			marginLeft.style.display = 'block';
		}
	
		if(position.value == 'tr'){
			
			marginLeft.style.display = 'none';
			marginBottom.style.display = 'none';
			marginTop.style.display = 'block';
			marginRight.style.display = 'block';
		}
	
		if(position.value == 'br'){
			
			marginLeft.style.display = 'none';
			marginTop.style.display = 'none';
			marginBottom.style.display = 'block';
			marginRight.style.display = 'block';
		}
	
		if(position.value == 'bl'){
			
			marginRight.style.display = 'none';
			marginTop.style.display = 'none';
			marginBottom.style.display = 'block';
			marginLeft.style.display = 'block';
		}
	
		let newOptions	= {		
			size 			: document.getElementById('badge-size').value,
			position 		: position.value,
			marginTop 		: document.getElementById('badge-margin-top').value,
			marginBottom	: document.getElementById('badge-margin-bottom').value,
			marginLeft 		: document.getElementById('badge-margin-left').value,
			marginRight 	: document.getElementById('badge-margin-right').value,
			icon 			: document.querySelector('input[name="icon"]:checked').value,
			buttonText		: document.getElementById('badge-text').value, 
			buttonColor		: document.getElementById('badge-color').value,
			link			: profile.metadata.newReviewUri,
			rating			: profile.avgRating,
			reviewCount		: profile.totalReviewCount || 0,
			border			: document.getElementById('badge-border').value
		};
		
		setOptions(newOptions);
	}
	
	const onSubmitError = (response) => {
       
		notifications.notify(t('Something went wrong, please try again later.'), 'error');        
    }
	
	const onSubmit = (e) => {
	
        e.preventDefault();
		
        businessesWidget.update(params.locationId, widgetId, {data: options}, onSubmitError).then((response) => {
         
			if (response.error) {
			
				onSubmitError(response);
            }else if (response !== false) {
		
                notifications.notify(t('Publication has been updated.'), 'success');
				navigator.clipboard.writeText(code);
            }
        }).finally(() => {
		
        });
    }
	//TODO - change stars rating to more simple and light solution without bg image
	const getRatingRange = (rval) =>{
		
		let formatted = 0;		
			
		if(rval > 0 && rval < 1){
			formatted = 5;
		}
		if(rval == 1){
			formatted = 10;
		}
		if(rval > 1 && rval < 2){
			formatted = 15;
		}
		if(rval == 2){
			formatted = 20;
		}
		if(rval > 2 && rval < 3){
			formatted = 25;
		}
		if(rval == 3){
			formatted = 30;
		}
		if(rval > 3 && rval < 4){
			formatted = 35;
		}
		if(rval == 4){
			formatted = 40;
		}
		if(rval > 4 && rval < 5){
			formatted = 45;
		}
		if(rval == 5){
			formatted = 50;
		}
		
		return formatted;
	}
	
	return (
  	
          <>
  			
  			<BusinessViewHeader locationId={params.locationId} onProfileRefresh={onProfileRefresh} />
  			
  			<BusinessViewMenu locationId={params.locationId} active="widget" />
     
  			{options && (
  			<form action="#" onChange={(e) => {generateWidget()}}>
  			<div className={'row'}>
  				<div className={'col-lg-8'}>
  					<div className="card border-0 shadow-sm mb-3">
  						<div className="px-4 py-3 border-bottom">
  							<h5 className="fw-semibold mb-0"><i className="ti ti-settings me-2 text-primary"></i>{t('Widget Generator')}</h5>
  						</div>
  						<div className="card-body">
  							<h6 className="fw-semibold text-muted text-uppercase fs-2 mb-3"><i className="ti ti-layout me-1"></i>{t('Typ & Position')}</h6>
  							<div className={'row'}>
  								<div className={'col-lg-6'}>
  									<div className={'form-group mb-3'}>
  										<label htmlFor="badge-size" className="form-label fw-semibold">{t('Badge Type')}</label>
  										<select id={'badge-size'} name="size" className={'form-control form-select'} value={options.size} onChange={(e) => {generateWidget()}}>
											<option value={'pill'}>{t('Glass Pill')}</option>
											<option value={'float'}>{t('Floating Bubble')}</option>
											<option value={'trust'}>{t('Trust Card')}</option>
											<option value={'banner'}>{t('Modern Banner')}</option>
  										</select>
  									</div>
  								</div>
  								<div className={'col-lg-6'}>
  									<div className={'form-group mb-3'}>
  										<label htmlFor="badge-position" className="form-label fw-semibold">{t('Badge Position')}</label>
  										<select id={'badge-position'} name="position" className={'form-control form-select'} value={options.position} onChange={(e) => {generateWidget()}}>
  											<option value={'tl'}>{t('Top Left')}</option>
  											<option value={'tr'}>{t('Top Right')}</option>
  											<option value={'br'}>{t('Bottom Right')}</option>
  											<option value={'bl'}>{t('Bottom Left')}</option>
  										</select>
  									</div>
  								</div>
  							</div>
  							<h6 className="fw-semibold text-muted text-uppercase fs-2 mb-3 mt-2"><i className="ti ti-spacing me-1"></i>{t('Abstände')}</h6>
  							<div className={'row'}>
  								<div id="badgeLeft" className={'col-lg-3'} style={{display : options.position == 'tr' || options.position == 'br' ? 'none' : 'block'}}>
  									<div className={'form-group mb-3'}>
  										<label htmlFor="badge-margin-left" className="form-label fw-semibold">{t('Margin Left')}</label>
  										<input type="number" id={'badge-margin-left'} name="marginLeft" className={'form-control'} defaultValue={options.marginLeft} />
  									</div>
  								</div>
  								<div id="badgeRight" className={'col-lg-3'} style={{display : options.position == 'tl' || options.position == 'bl' ? 'none' : 'block'}}>
  									<div className={'form-group mb-3'}>
  										<label htmlFor="badge-margin-right" className="form-label fw-semibold">{t('Margin Right')}</label>
  										<input type="number" id={'badge-margin-right'} name="marginLeft" className={'form-control'} defaultValue={options.marginLeft} />
  									</div>
  								</div>
  								<div id="badgeTop" className={'col-lg-3'} style={{display : options.position == 'bl' || options.position == 'br' ? 'none' : 'block'}}>
  									<div className={'form-group mb-3'}>
  										<label htmlFor="badge-margin-top" className="form-label fw-semibold">{t('Margin Top')}</label>
  										<input type="number" id={'badge-margin-top'} name="marginTop" className={'form-control'} defaultValue={options.marginTop} />
  									</div>
  								</div>
  								<div id="badgeBottom" className={'col-lg-3'} style={{display : options.position == 'tl' || options.position == 'tr' ? 'none' : 'block'}}>
  									<div className={'form-group mb-3'}>
  										<label htmlFor="badge-margin-bottom" className="form-label fw-semibold">{t('Margin Bottom')}</label>
  										<input type="number" id={'badge-margin-bottom'} name="marginBottom" className={'form-control'} defaultValue={options.marginBottom} />
  									</div>
  								</div>
  							</div>
  							<h6 className="fw-semibold text-muted text-uppercase fs-2 mb-3 mt-2"><i className="ti ti-palette me-1"></i>{t('Aussehen')}</h6>
  							<div className={'row'}>
  								<div id="badgeText" className={'col-lg-4'}>
  									<div className={'form-group mb-3'}>
  										<label htmlFor="badge-text" className="form-label fw-semibold">{t('Button Text')}</label>
  										<input type="text" id={'badge-text'} name="button[text]" className={'form-control'} defaultValue={options.buttonText} />
  									</div>
  								</div>
  								<div id="badgeBorder" className={'col-lg-4'}>
  									<div className={'form-group mb-3'}>
  										<label htmlFor="badge-border" className="form-label fw-semibold">{t('Show Border?')}</label>
  										<select id={'badge-border'} name="border" className={'form-control form-select'} value={options.border ? options.border : 'yes'} onChange={(e) => {generateWidget()}}>
  											<option value={'yes'}>{t('Yes')}</option>
  											<option value={'no'}>{t('No')}</option>
  										</select>
  									</div>
  								</div>
  								<div id="badgeColor" className={'col-lg-4'}>
  									<div className={'form-group mb-3'}>
  										<label htmlFor="badge-color" className="form-label fw-semibold">{t('Button Color')}</label>
  										<div className="d-flex align-items-center gap-2">
  											<input type="color" id={'badge-color'} name="button[color]" className={'form-control form-control-color'} value={options.buttonColor || '#000000'} onChange={console.log('color')} style={{width: '50px', height: '38px'}} />
  											<span className="text-muted fs-2">{options.buttonColor || '#000000'}</span>
  										</div>
  									</div>
  								</div>
  							</div>
  						</div>
  					</div>
  				</div>
  				<div className={'col-lg-4'}>
  					<div className="card border-0 shadow-sm mb-3">
  						<div className="px-4 py-3 border-bottom">
  							<h5 className="fw-semibold mb-0"><i className="ti ti-code me-2 text-success"></i>{t('Embed Code')}</h5>
  						</div>
  						<div className="card-body">
  							<p className="text-muted fs-2 mb-3">{t('Kopiere diesen Code und füge ihn auf deiner Webseite ein.')}</p>
  							<div className="position-relative">
  								<pre id="intSript" className="rounded-3 p-3 mb-2" style={{whiteSpace:'pre-wrap', background:'#f8f9fa', border:'1px solid #e9ecef', fontSize:'12px'}}>{code}</pre>
  							</div>
  							<button className="btn btn-primary w-100" onClick={onSubmit}><i className="ti ti-clipboard-copy me-2"></i>{t('Save & Copy')}</button>
  						</div>
  					</div>
  				</div>
  			</div>
  			<div className={'row'}>
  				<div className={'col-lg-12'}>
  					<div className="card border-0 shadow-sm mb-3">
  						<div className="px-4 py-3 border-bottom">
  							<h5 className="fw-semibold mb-0"><i className="ti ti-eye me-2 text-info"></i>{t('Badge view')}</h5>
  						</div>
  						<div className="card-body">
						<style>{`
  ${style}
  .lb-pill-preview{display:inline-flex !important;align-items:center;gap:8px;padding:10px 16px;border-radius:50px;box-shadow:0 4px 16px rgba(0,0,0,0.12);background:rgba(255,255,255,0.85);backdrop-filter:blur(16px);-webkit-backdrop-filter:blur(16px);font-family:Arial,sans-serif;}
  .lb-pill-preview img{width:18px;height:18px;flex-shrink:0;}
  .lb-pill-preview .lb-pill-rating{display:flex;align-items:center;gap:6px;}
  .lb-pill-preview .lb-pill-num{font-size:14px;font-weight:700;color:#111827;}
  .lb-pill-preview .lb-pill-stars{height:12px;width:64px;background:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 16"><text y="14" font-size="14" fill="%23f59e0b">★★★★★</text></svg>') no-repeat;background-size:contain;}
  .lb-pill-preview .lb-pill-btn{display:inline-block;border-radius:50px;font-size:11px;padding:6px 14px;color:white;text-decoration:none;font-weight:600;white-space:nowrap;}
  .lb-trust-preview{width:200px;border-radius:14px;box-shadow:0 4px 24px rgba(0,0,0,0.10);background:white;overflow:hidden;font-family:Arial,sans-serif;}
  .lb-trust-preview .lb-trust-inner{padding:16px;}
  .lb-trust-preview .lb-trust-header{display:flex;align-items:center;gap:10px;margin-bottom:14px;}
  .lb-trust-preview .lb-trust-icon{width:36px;height:36px;border-radius:10px;background:#eff6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
  .lb-trust-preview .lb-trust-icon img{width:22px;height:22px;}
  .lb-trust-preview .lb-trust-lbl{font-size:11px;font-weight:500;color:#9ca3af;text-transform:uppercase;letter-spacing:0.05em;}
  .lb-trust-preview .lb-trust-sub{font-size:11px;color:#b0b0b0;}
  .lb-trust-preview .lb-trust-score{font-size:28px;font-weight:800;color:#111827;letter-spacing:-0.02em;margin-bottom:4px;}
  .lb-trust-preview .lb-trust-score small{font-size:12px;color:#9ca3af;font-weight:400;}
  .lb-trust-preview .lb-trust-stars{height:14px;width:70px;background:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 16"><text y="14" font-size="14" fill="%23f59e0b">★★★★★</text></svg>') no-repeat;background-size:contain;margin-bottom:6px;}
  .lb-trust-preview .lb-trust-count{font-size:11px;color:#9ca3af;margin-bottom:12px;}
  .lb-trust-preview .lb-trust-btn{display:block;width:100%;text-align:center;border-radius:10px;font-size:13px;padding:10px 14px;color:white;text-decoration:none;font-weight:600;box-sizing:border-box;}
  .lb-trust-preview .lb-trust-stripe{height:3px;background:linear-gradient(to right,#4285F4,#EA4335,#FBBC05,#34A853);}
  .lb-float-closed{width:64px;height:64px;border-radius:50%;box-shadow:0 4px 20px rgba(0,0,0,0.18);background:white;display:flex;align-items:center;justify-content:center;position:relative;font-family:Arial,sans-serif;}
  .lb-float-closed img{width:28px;height:28px;}
  .lb-float-closed .lb-float-num{position:absolute;top:2px;right:2px;background:#2563eb;color:white;font-size:9px;font-weight:700;width:20px;height:20px;border-radius:50%;display:flex;align-items:center;justify-content:center;}
  .lb-float-expanded{width:240px;border-radius:16px;padding:20px;box-shadow:0 4px 24px rgba(0,0,0,0.16);background:white;font-family:Arial,sans-serif;}
  .lb-float-expanded .lb-fexp-header{display:flex;align-items:center;gap:12px;margin-bottom:16px;}
  .lb-float-expanded .lb-fexp-icon{width:48px;height:48px;border-radius:50%;background:#f9fafb;border:1px solid #f3f4f6;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
  .lb-float-expanded .lb-fexp-icon img{width:24px;height:24px;}
  .lb-float-expanded .lb-fexp-title{font-size:14px;font-weight:700;color:#111827;}
  .lb-float-expanded .lb-fexp-count{font-size:12px;color:#9ca3af;}
  .lb-float-expanded .lb-fexp-score{display:flex;align-items:center;gap:12px;margin-bottom:16px;}
  .lb-float-expanded .lb-fexp-num{font-size:32px;font-weight:900;color:#111827;letter-spacing:-0.03em;}
  .lb-float-expanded .lb-fexp-stars{height:14px;width:70px;background:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 16"><text y="14" font-size="14" fill="%23f59e0b">★★★★★</text></svg>') no-repeat;background-size:contain;}
  .lb-float-expanded .lb-fexp-label{font-size:10px;color:#9ca3af;margin-top:2px;}
  .lb-float-expanded .lb-fexp-btn{display:block;width:100%;border-radius:12px;font-size:14px;padding:10px 16px;font-weight:600;text-align:center;color:white;text-decoration:none;box-sizing:border-box;}
  .lb-banner-preview{width:340px;border-radius:14px;box-shadow:0 4px 24px rgba(0,0,0,0.10);background:rgba(255,255,255,0.95);backdrop-filter:blur(20px);-webkit-backdrop-filter:blur(20px);overflow:hidden;font-family:Arial,sans-serif;}
  .lb-banner-preview .lb-banner-body{padding:16px;display:flex;gap:14px;}
  .lb-banner-preview .lb-banner-icon{width:44px;height:44px;border-radius:12px;background:white;box-shadow:0 1px 4px rgba(0,0,0,0.08);border:1px solid #f3f4f6;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
  .lb-banner-preview .lb-banner-icon img{width:20px;height:20px;}
  .lb-banner-preview .lb-banner-info{flex:1;min-width:0;}
  .lb-banner-preview .lb-banner-head{display:flex;align-items:center;justify-content:space-between;margin-bottom:4px;}
  .lb-banner-preview .lb-banner-lbl{font-size:10px;font-weight:500;color:#9ca3af;text-transform:uppercase;letter-spacing:0.05em;}
  .lb-banner-preview .lb-banner-score{font-size:20px;font-weight:900;color:#111827;letter-spacing:-0.03em;}
  .lb-banner-preview .lb-banner-score small{font-size:10px;color:#9ca3af;font-weight:400;}
  .lb-banner-preview .lb-banner-srow{display:flex;align-items:center;gap:6px;margin-bottom:8px;}
  .lb-banner-preview .lb-banner-stars{height:12px;width:64px;background:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 16"><text y="14" font-size="14" fill="%23f59e0b">★★★★★</text></svg>') no-repeat;background-size:contain;}
  .lb-banner-preview .lb-banner-cnt{font-size:10px;color:#9ca3af;}
  .lb-banner-preview .lb-banner-bars{display:flex;flex-direction:column;gap:3px;}
  .lb-banner-preview .lb-banner-bar{display:flex;align-items:center;gap:6px;font-size:10px;}
  .lb-banner-preview .lb-banner-bar-l{color:#6b7280;width:8px;text-align:right;}
  .lb-banner-preview .lb-banner-bar-t{flex:1;height:4px;background:#f3f4f6;border-radius:4px;overflow:hidden;}
  .lb-banner-preview .lb-banner-bar-f{height:100%;background:#f59e0b;border-radius:4px;}
  .lb-banner-preview .lb-banner-bar-c{color:#d1d5db;width:20px;text-align:right;}
  .lb-banner-preview .lb-banner-btn{display:flex;align-items:center;justify-content:center;gap:4px;width:100%;font-size:13px;padding:10px 16px;font-weight:600;color:white;text-decoration:none;text-align:center;}
  `}</style>
  						<div className={'row justify-content-center'}>

  							{options.size === 'pill' ? (
  								<div className={'col-lg-12 text-center py-3'}>
  									<input style={{display:'none'}} type="radio" name="icon" id={'badge-margin-icon-0'} defaultValue={options.icon || 0} defaultChecked={true} />
  									<div className="lb-pill-preview">
  										<img src={icons[options.icon || 0]} alt="Google" />
  										<div className="lb-pill-rating">
  											<span className="lb-pill-num">{Math.round(profile.avgRating*10)/10}</span>
  											<div className="lb-pill-stars"></div>
  										</div>
  										<a href="#" className="lb-pill-btn" style={{backgroundColor:options.buttonColor}}>{options.buttonText}</a>
  									</div>
  								</div>

  							) : options.size === 'trust' ? (
  								<div className={'col-lg-12 d-flex justify-content-center py-3'}>
  									<input style={{display:'none'}} type="radio" name="icon" id={'badge-margin-icon-0'} defaultValue={options.icon || 0} defaultChecked={true} />
  									<div className="lb-trust-preview">
  										<div className="lb-trust-inner">
  											<div className="lb-trust-header">
  												<div className="lb-trust-icon"><img src={icons[options.icon || 0]} alt="Google" /></div>
  												<div>
  													<div className="lb-trust-lbl">Google</div>
  													<div className="lb-trust-sub">Bewertungen</div>
  												</div>
  											</div>
  											<div className="lb-trust-score">{Math.round(profile.avgRating*10)/10}<small> /5</small></div>
  											<div className="lb-trust-stars"></div>
  											<div className="lb-trust-count">{profile.totalReviewCount || 0} Bewertungen</div>
  										</div>
  										<div style={{padding:'0 16px 16px'}}>
  											<a href="#" className="lb-trust-btn" style={{backgroundColor:options.buttonColor}}>{options.buttonText}</a>
  										</div>
  										<div className="lb-trust-stripe"></div>
  									</div>
  								</div>

  							) : options.size === 'float' ? (
  								<div className={'col-lg-12 py-3'}>
  									<input style={{display:'none'}} type="radio" name="icon" id={'badge-margin-icon-0'} defaultValue={options.icon || 0} defaultChecked={true} />
  									<div className="d-flex align-items-end gap-4 flex-wrap justify-content-center">
  										<div className="text-center">
  											<div style={{fontSize:'10px',color:'#9ca3af',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:6}}>Geschlossen</div>
  											<div className="lb-float-closed">
  												<img src={icons[options.icon || 0]} alt="Google" />
  												<div className="lb-float-num">{Math.round(profile.avgRating)}</div>
  											</div>
  										</div>
  										<div style={{fontSize:'20px',color:'#d1d5db',marginBottom:22}}>→</div>
  										<div className="text-center">
  											<div style={{fontSize:'10px',color:'#9ca3af',textTransform:'uppercase',letterSpacing:'0.05em',marginBottom:6}}>Bei Hover</div>
  											<div className="lb-float-expanded">
  												<div className="lb-fexp-header">
  													<div className="lb-fexp-icon"><img src={icons[options.icon || 0]} alt="Google" /></div>
  													<div>
  														<div className="lb-fexp-title">Google Bewertungen</div>
  														<div className="lb-fexp-count">{profile.totalReviewCount || 0} Bewertungen</div>
  													</div>
  												</div>
  												<div className="lb-fexp-score">
  													<span className="lb-fexp-num">{Math.round(profile.avgRating*10)/10}</span>
  													<div>
  														<div className="lb-fexp-stars"></div>
  														<div className="lb-fexp-label">Ausgezeichnet</div>
  													</div>
  												</div>
  												<a href="#" className="lb-fexp-btn" style={{backgroundColor:options.buttonColor}}>{options.buttonText}</a>
  											</div>
  										</div>
  									</div>
  								</div>

  							) : options.size === 'banner' ? (
  								<div className={'col-lg-12 d-flex justify-content-center py-3'}>
  									<input style={{display:'none'}} type="radio" name="icon" id={'badge-margin-icon-0'} defaultValue={options.icon || 0} defaultChecked={true} />
  									<div className="lb-banner-preview">
  										<div className="lb-banner-body">
  											<div className="lb-banner-icon"><img src={icons[options.icon || 0]} alt="Google" /></div>
  											<div className="lb-banner-info">
  												<div className="lb-banner-head">
  													<span className="lb-banner-lbl">Google Rating</span>
  													<div className="lb-banner-score">{Math.round(profile.avgRating*10)/10}<small>/5</small></div>
  												</div>
  												<div className="lb-banner-srow">
  													<div className="lb-banner-stars"></div>
  													<span className="lb-banner-cnt">{profile.totalReviewCount || 0} Bewertungen</span>
  												</div>
  												<div className="lb-banner-bars">
  													{[{s:5,p:85},{s:4,p:10},{s:3,p:3},{s:2,p:1},{s:1,p:1}].map(b => (
  														<div className="lb-banner-bar" key={b.s}>
  															<span className="lb-banner-bar-l">{b.s}</span>
  															<div className="lb-banner-bar-t"><div className="lb-banner-bar-f" style={{width:b.p+'%'}}></div></div>
  															<span className="lb-banner-bar-c">{Math.round((profile.totalReviewCount||0)*b.p/100)}</span>
  														</div>
  													))}
  												</div>
  											</div>
  										</div>
  										<a href="#" className="lb-banner-btn" style={{backgroundColor:options.buttonColor}}>{options.buttonText} ›</a>
  									</div>
  								</div>

  							) : (
  								<>
  									{options && icons.map((icon, index) => {
  										return (
  											<div className={'col-lg-'+ (options.size == 'l' ? 6 : 2)} key={index}>
  												<div className={'form-group py-2'}>
  													<input style={{display:'block'}} type="radio" name="icon" id={'badge-margin-icon-'+index} className={'mb-2 form-check-input'} defaultValue={index} defaultChecked={index == options.icon ? true : false} />
  													<div className={'lbGbadge-wraper lbGbadge-'+options.position+' lbGbadge-'+options.size+' lbGbadge-border-' + (options.border!=undefined ? options.border : 'yes')}>
  														<a href="#" className={'lbGbadge-link'}>
  															<img src={icon}/>
  															<div className={'lbGbadge-rating lbGbadge-rating-'+getRatingRange(profile.avgRating)}><span>{Math.round(profile.avgRating)}</span></div>
  														</a>
  														<a href="#" className={'lbGbadge-btn'} style={{backgroundColor:options.buttonColor}}>{options.buttonText}</a>
  													</div>
  												</div>
  											</div>
  										)
  									})}
  								</>
  							)}
  						</div>
  						</div>
  					</div>
  				</div>
  			</div>
  			</form>
  			)}
          </>
      );
  }
  export default BusinessesWidget;